var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"floor-fee-summary-container"},[_c('div',{staticStyle:{"height":"300px","width":"100%"},attrs:{"id":"floorFeeSummary"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }